(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2455],{

/***/ 72455:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "LayoutWidget015": function() { return /* binding */ LayoutWidget015; },
  "default": function() { return /* binding */ LayoutWidget015_LayoutWidget015; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./src/features/translations/index.js + 3 modules
var translations = __webpack_require__(91929);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/shared/components/index.js + 115 modules
var components = __webpack_require__(87900);
// EXTERNAL MODULE: ./src/shared/contexts/ViewMode/index.js + 5 modules
var ViewMode = __webpack_require__(32667);
// EXTERNAL MODULE: ./node_modules/swiper/react/swiper-react.js + 14 modules
var swiper_react = __webpack_require__(88494);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./src/components/RichTextWidget/index.js + 11 modules
var RichTextWidget = __webpack_require__(14258);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/shared/utils/index.js + 10 modules
var utils = __webpack_require__(63414);
// EXTERNAL MODULE: ./src/components/widgets/layout-widget/LayoutWidget015/Item/Item.module.scss
var Item_module = __webpack_require__(87765);
var Item_module_default = /*#__PURE__*/__webpack_require__.n(Item_module);
;// CONCATENATED MODULE: ./src/components/widgets/layout-widget/LayoutWidget015/Item/Item.jsx









var DEFAULT_VISIBLE_LETTERS = 120;
var Item = function(param) {
    var course = param.course, heading = param.heading, description = param.description, appearance = param.appearance, startDate = param.startDate;
    var locale = (0,router.useRouter)().locale;
    var truncatedDescription = (0,react.useMemo)(function() {
        return (0,utils/* truncateText */.aF)(description, DEFAULT_VISIBLE_LETTERS);
    }, [
        description
    ]);
    var date = (0,react.useMemo)(function() {
        return (0,utils/* formatDate */.p6)(startDate, locale);
    }, [
        startDate,
        locale
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* PageLink */.H_, {
        directory: "programs",
        slug: course === null || course === void 0 ? void 0 : course.slug,
        className: (Item_module_default()).link,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: classnames_default()((Item_module_default()).wrapper, (0,_define_property/* default */.Z)({}, (Item_module_default()).grey, appearance === "light")),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (Item_module_default())["content-inner"],
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Heading5 */.by, {
                                    className: (Item_module_default()).title,
                                    color: "dark",
                                    children: heading
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(RichTextWidget/* RichText */.H, {
                                    value: truncatedDescription,
                                    className: (Item_module_default()).courses
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Paragraph */.nv, {
                            color: "grey",
                            appearance: "smaller",
                            children: date
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: (Item_module_default()).arrow,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Icon */.JO, {
                        className: (Item_module_default()).icon,
                        name: "arrow_right"
                    })
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/widgets/layout-widget/LayoutWidget015/Item/index.js


// EXTERNAL MODULE: ./src/components/widgets/layout-widget/LayoutWidget015/LayoutWidget015.module.scss
var LayoutWidget015_module = __webpack_require__(6840);
var LayoutWidget015_module_default = /*#__PURE__*/__webpack_require__.n(LayoutWidget015_module);
;// CONCATENATED MODULE: ./src/components/widgets/layout-widget/LayoutWidget015/LayoutWidget015.jsx










var LayoutWidget015 = function(param) {
    var payload = param.payload;
    var ref;
    var title = (ref = payload === null || payload === void 0 ? void 0 : payload.title) !== null && ref !== void 0 ? ref : "";
    var ref1;
    var appearance = (ref1 = payload === null || payload === void 0 ? void 0 : payload.template) !== null && ref1 !== void 0 ? ref1 : "light";
    var ref2;
    var courses = (ref2 = payload === null || payload === void 0 ? void 0 : payload.items) !== null && ref2 !== void 0 ? ref2 : [];
    var t = (0,translations/* useTranslation */.$)().t;
    var prevRef = (0,react.useRef)(null);
    var nextRef = (0,react.useRef)(null);
    var isDesktop = (0,ViewMode/* useViewMode */.mJ)().isDesktop;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()((LayoutWidget015_module_default()).wrapper, (LayoutWidget015_module_default())[appearance]),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Container */.W2, {
                className: (LayoutWidget015_module_default()).inner,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (LayoutWidget015_module_default()).header,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Heading3 */.aC, {
                            className: (LayoutWidget015_module_default()).title,
                            children: t(title)
                        }),
                        courses.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: isDesktop && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (LayoutWidget015_module_default())["navigation-wrapper"],
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (LayoutWidget015_module_default())["slider-navigation"],
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            ref: prevRef,
                                            className: classnames_default()((LayoutWidget015_module_default()).navigation, (LayoutWidget015_module_default())["navigation-prev"]),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Icon */.JO, {
                                                className: (LayoutWidget015_module_default()).icon,
                                                name: "arrow_slider_prev"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            ref: nextRef,
                                            className: classnames_default()((LayoutWidget015_module_default()).navigation, (LayoutWidget015_module_default())["navigation-next"]),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Icon */.JO, {
                                                className: (LayoutWidget015_module_default()).icon,
                                                name: "arrow_slider_next"
                                            })
                                        })
                                    ]
                                })
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (LayoutWidget015_module_default()).slider,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* SwiperLayout */.OJ, {
                    prevRef: prevRef,
                    nextRef: nextRef,
                    watchOverflow: false,
                    slidesPerView: "auto",
                    spaceBetween: 8,
                    slidesPerGroup: 1,
                    slidesOffsetAfter: 30,
                    children: courses.map(function(item) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                            className: (LayoutWidget015_module_default()).slide,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Item, (0,_object_spread/* default */.Z)({
                                appearance: appearance
                            }, item))
                        }, item.id);
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var LayoutWidget015_LayoutWidget015 = (LayoutWidget015);


/***/ }),

/***/ 87765:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Item_wrapper__4d_Aj","grey":"Item_grey__3vWvq","link":"Item_link__b5S4b","title":"Item_title__Ps8Yl","courses":"Item_courses__U5wKj","arrow":"Item_arrow__5jc7_","icon":"Item_icon__yzWqb","content-inner":"Item_content-inner__Y36Jk"};

/***/ }),

/***/ 6840:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"LayoutWidget015_wrapper__fqbXY","light":"LayoutWidget015_light__6re_o","grey":"LayoutWidget015_grey__TlJLQ","header":"LayoutWidget015_header__Dsvt5","title":"LayoutWidget015_title__OnCIE","slider":"LayoutWidget015_slider__DL9Ug","slider-navigation":"LayoutWidget015_slider-navigation__qUy90","navigation":"LayoutWidget015_navigation__VGmVW","navigation-prev":"LayoutWidget015_navigation-prev__gMcXP","navigation-next":"LayoutWidget015_navigation-next__eyJ8l","slide":"LayoutWidget015_slide__T6_ue"};

/***/ })

}]);